import React, { ReactElement, useContext, useEffect, useState } from 'react'
import ClaimedArtWork from './ClaimedArtWork'
import { Context } from '@/components/Context'
import Box from '@/components/boxes/Box'
import { UpdateType } from '@/types/websocket'

const ClaimsOverview = (): ReactElement => {
    const { claimedDataList, setActiveUpdates } = useContext(Context)
    const [totalClaims, setTotalClaims] = useState(0)

    useEffect(() => {
        setActiveUpdates([UpdateType.CLAIMS])
    }, [])

    useEffect(() => {
        const total = claimedDataList.reduce((acc, claimData) => acc + Number(claimData.claim.amount), 0)
        setTotalClaims(total)
    }, [claimedDataList])

    return (
        <div>
            <h1 className="title">Your&nbsp;Claim</h1>
            <div className="container">
                <div className="header-container bottom">
                    <Box
                        caption={'Claims'}
                        text={totalClaims.toFixed(2)}
                        styleCaption={'gray large bold'}
                        styleText={'center'}
                    />
                </div>
                <div className="prompts">
                    {claimedDataList.reverse().map((claimData) => (
                        <div key={claimData.claim.id} className={'bottom'}>
                            <ClaimedArtWork key={claimData.claim.id} claimData={claimData} />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default ClaimsOverview
